import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Navigation } from "./components/sections/Navigation";
import { HeroSection } from "./components/sections/HeroSection";
import { AboutSection } from "./components/sections/AboutSection";
import { MapDividerSection } from "./components/sections/MapDividerSection";
import { VisionSection } from "./components/sections/VisionSection";
import { ObjectivesSection } from "./components/sections/ObjectivesSection";
import { RoadmapSection } from "./components/sections/RoadmapSection";
import { KenyaStatsSection } from "./components/sections/KenyaStatsSection";
import { ChallengeSection } from "./components/sections/ChallengeSection";
import { RankingsSection } from "./components/sections/RankingsSection";
import { PartnersSection } from "./components/sections/PartnersSection";
import { ValuesSection } from "./components/sections/ValuesSection";
import { Footer } from "./components/sections/Footer";
import { LeagueTablePage } from "./pages/LeagueTablePage";
import { FixturesPage, ResultsPage } from "./pages/MatchesPage";
import { FantasyPage } from "./pages/FantasyPage";
import { SocialFloatMobile, SocialSidebar } from "./components/common/SocialSidebar";

const ScrollToHash = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }

    const timeout = window.setTimeout(() => {
      const target = document.querySelector(location.hash);
      if (target) {
        const navOffset = 96;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - navOffset;
        window.scrollTo({ top: targetTop, behavior: "smooth" });
      }
    }, 120);

    return () => window.clearTimeout(timeout);
  }, [location]);

  return null;
};

const HomePage = () => {
  return (
    <div className="App relative" data-testid="app-container">
      <Navigation />
      <HeroSection />
      <MapDividerSection testId="map-divider-hero-vision" mapPosition="58% 8%" />
      <VisionSection />
      <MapDividerSection testId="map-divider-vision-objectives" mapPosition="58% 18%" />
      <ObjectivesSection />
      <MapDividerSection testId="map-divider-objectives-roadmap" mapPosition="58% 30%" />
      <RoadmapSection />
      <MapDividerSection testId="map-divider-roadmap-kenya" mapPosition="58% 42%" />
      <KenyaStatsSection />
      <MapDividerSection testId="map-divider-kenya-challenge" mapPosition="58% 55%" />
      <ChallengeSection />
      <MapDividerSection testId="map-divider-challenge-rankings" mapPosition="58% 68%" />
      <RankingsSection />
      <MapDividerSection testId="map-divider-rankings-partners" mapPosition="58% 80%" />
      <PartnersSection />
      <MapDividerSection testId="map-divider-partners-values" mapPosition="58% 90%" />
      <ValuesSection />
      <Footer />
    </div>
  );
};

const AboutPage = () => {
  return (
    <div className="App" data-testid="about-page-container">
      <Navigation />
      <AboutSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <>
      <ScrollToHash />
      <SocialSidebar />
      <SocialFloatMobile />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-kpl" element={<AboutPage />} />
        <Route path="/league-table" element={<LeagueTablePage />} />
        <Route path="/fixtures" element={<FixturesPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/fantasy" element={<FantasyPage /> } />
      </Routes>
    </>
  );
}

export default App;
